import React from "react";
import { Link } from "react-router-dom";

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pages = [];

        if (totalPages <= 1) {
            return [1];
        }

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);

            if (currentPage > 4) {
                pages.push("...");
            }

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            let adjustedStart = start;
            let adjustedEnd = end;

            if (currentPage <= 4) {
                adjustedEnd = 5;
            } else if (currentPage >= totalPages - 3) {
                adjustedStart = totalPages - 4;
            }

            for (let i = adjustedStart; i <= adjustedEnd; i++) {
                if (!pages.includes(i)) {
                    pages.push(i);
                }
            }

            if (currentPage < totalPages - 3) {
                pages.push("...");
            }

            if (!pages.includes(totalPages)) {
                pages.push(totalPages);
            }
        }

        return pages;
    };

    const pages = getPageNumbers();

    return (
        <nav aria-label="Standard pagination example">
            <ul className="pagination justify-content-end mb-0">
                <li className={`page-item ${currentPage <= 1 ? "disabled" : ""}`}>
                    <Link
                        className="page-link"
                        to="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (currentPage > 1) onPageChange(currentPage - 1);
                        }}
                    >
                        Previous
                    </Link>
                </li>

                {pages.map((page, index) => (
                    <li
                        key={index}
                        className={`page-item ${currentPage === page ? "active" : ""} ${page === "..." || (totalPages <= 1 && page === 1) ? "active" : ""
                            } ${page === "..." ? "disabled" : ""}`}
                    >
                        {page === "..." ? (
                            <span className="page-link">...</span>
                        ) : (
                            <Link
                                className="page-link"
                                to="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (totalPages > 1) onPageChange(page);
                                }}
                            >
                                {page}
                            </Link>
                        )}
                    </li>
                ))}

                <li
                    className={`page-item ${currentPage >= totalPages ? "disabled" : ""}`}
                >
                    <Link
                        className="page-link"
                        to="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (currentPage < totalPages) onPageChange(currentPage + 1);
                        }}
                    >
                        Next
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default PaginationComponent;
